import React, { useState } from 'react'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import { ReactComponent as PencilIcon } from '@/assets/icons/pencil-icon.svg'
import { ReactComponent as BarsIcon } from '@/assets/icons/bars-icon.svg'
import { ReactComponent as DoubleBarIcon } from '@/assets/icons/double-bar-icon.svg'
import { ReactComponent as BagdeIcon } from '@/assets/icons/badge-icon.svg'
import { ReactComponent as BoxesIcon } from '@/assets/icons/boxes-icon.svg'

import { ViewMenu } from '@/components/ViewMenu/ViewMenu'
import './FeedHeader.scoped.sass'

import store from '@/core/store'
import modalService from '@/services/modal.service'
import labelsService from '@/app-domains/labels/labels.service'
import BoxesService from '@/app-domains/boxes/boxes.service'

import { AddLabelModalContainer } from '@/components/SideMenu/components/BoxesMenu/components/AddBoxLabelButton/AddBoxLabelModalContainer/AddBoxLabelModalContainer'
import { AddBoxModalContainer } from '@/components/SideMenu/components/HomeMenu/components/AddBoxModalContainer/AddBoxModalContainer'
import { SortMenu } from '@/components/SortMenu/SortMenu'
import threadsService from '@/app-domains/threads/threads.service'

export function FeedHeader () {
  const [currentFilter, setCurrentFilter] = useState(store.getState().threads.currentFilter)
  const [currentBox, setCurrentBox] = useState('')
  const [currentLabel, setCurrentLabel] = useState(store.getState().threads.currentFilter.label || 'All messages')
  const [hasMultipleLabels, setHasMultipleLabels] = useState(false)
  const alternativeFilterKeys = ['Pinned', 'Drafts', 'Archived', 'Sent', 'Spam', 'Promotional', 'Deleted']

  useRenderEvent([
    'THREADS:UPDATED',
    'FILTERS:UPDATED',
    'FILTERS:CLEANED',
    'LABELS:UPDATED',
    'CONTAINERS:UPDATED',
  ], () => {
    const { currentFilter } = store.getState().threads

    setCurrentFilter(currentFilter)
    if (currentFilter?.type === 'Box') {
      const box = BoxesService.findBoxbyId(currentFilter.value)
      setCurrentBox(box.boxalias || box.boxname)
      const boxLabels = labelsService.findLabelsForBox(box)
      if (boxLabels.length > 1) {
        setHasMultipleLabels(true)
      } else {
        setHasMultipleLabels(false)
      }
      return setCurrentLabel(boxLabels.map(l => l.name).join(', '))
    }
    if (currentFilter.type === 'Label') {
      setHasMultipleLabels(false)

      return setCurrentLabel(labelsService.findLabelById(currentFilter.value)?.name)
    }
    if (currentFilter.value === 'no-label') {
      return setCurrentLabel('Unlabeled')
    }

    if (alternativeFilterKeys.includes(currentFilter.type)) {
      return setCurrentLabel(currentFilter.label)
    }

    return setCurrentLabel('All Messages')
  })

  const showEditLabelModal = () => {
    let label
    if (currentFilter?.type === 'Box') {
      const box = BoxesService.findBoxbyId(currentFilter.value)
      label = labelsService.findLabelsForBox(box)[0]
    } else {
      label = labelsService.findLabelById(currentFilter.value)
    }
    if (label) {
      modalService.open(<AddLabelModalContainer label={label} closeAddLabelModal={() => modalService.close()} />)
    }
  }

  const showEditBoxModal = () => {
    const box = BoxesService.findBoxbyId(currentFilter.value)
    if (box) {
      modalService.open(<AddBoxModalContainer box={box} closeAddLabelModal={() => modalService.close()} />)
    }
  }

  const selectThreadFilteringMode = (mode) => {
    threadsService.switchFilterUnreadOrReadMode(mode === 'Only unread')
  }

  const changeViewType = (type) => store.commit('UI:view_feed_change', type)
 
  const isLabelEditable = (currentFilter, currentLabel) => !hasMultipleLabels && (
    currentFilter?.type === 'Label' ||
      (currentFilter?.type === 'Box' && (currentLabel && currentLabel !== 'Unlabeled'))
  )

  const shouldShowLabelIcon = currentFilter => currentFilter && currentLabel !== 'All messages' && currentFilter.type !== 'all' && currentFilter.type !== 'no-label'

  return <div className='feed-header'>
    <div className="feed-header-left">
      <div className="label-name">
        { shouldShowLabelIcon(currentFilter) && <span className='label-icon-feed-header'><BagdeIcon /></span>}
        <span>{currentLabel || 'Unlabeled'}</span>
        { isLabelEditable(currentFilter, currentLabel) && <PencilIcon className='cursor-pointer' onClick={showEditLabelModal} />}
      </div>
      {currentFilter?.type === 'Box' && <div className="box-name">
        <span className='box-icon'><BoxesIcon /></span>
        <span className='box-name-span'>{currentBox}</span>
        <PencilIcon className='cursor-pointer' onClick={showEditBoxModal} />
      </div>}
      <div className='thread-mode-selector'>
        <SortMenu noTitle={true} selectedSortType='All threads' sortValues={['All threads', 'Only unread']} selectSortType={selectThreadFilteringMode} right={true}></SortMenu>
      </div>
    </div>
    <div className="feed-header-right">
      <ViewMenu options={[{
        label: 'normal',
        icon: <DoubleBarIcon />,
        action: () => changeViewType('normal'),
        active: true
      },
      {
        label: 'dense',
        action: () => changeViewType('dense'),
        icon: <BarsIcon />
      }
      ]} />
    </div>
  </div>
}
